import gql from 'graphql-tag';

import { CONTROL_PHOTO_FRAGMENT } from './controlPhoto';

export const WAREHOUSE_DELIVERY_PRODUCT_FRAGMENT = gql`
    fragment WarehouseDeliveryProductFragment on WarehouseDeliveryProduct {
        conditionning
        packagesPerBatch
        location
        photoUrl
        productId
        productIndex
        productLabel
        packages
        packagesPicked
        scan
    }
`;

export const URBANTZ_DELIVERY_FRAGMENT = gql`
    fragment URBANTZ_DELIVERY_FRAGMENT on WarehouseDelivery {
        label
        roundColor
        roundName
        serviceTime
        theoricServiceTime
        times {
            preferenceSlot {
                start
                end
            }
            actualSlot {
                start
                end
            }
        }
        trackingUrl
        photos {
            type
            urls
        }
        controlPhotos {
            ...ControlPhotoFragment
        }
    }
    ${CONTROL_PHOTO_FRAGMENT}
`;

export const WAREHOUSE_DELIVERY_FRAGMENT = gql`
    fragment WarehouseDeliveryFragment on WarehouseDelivery {
        _id
        createdAt
        deliveryCode
        deliveryDate
        siteId
        site {
            name
            organizationName
        }
        operatorName
        warehouseColumnId
        warehouseColumn {
            name
        }
        state
        stateHistory {
            state
            createdAt
            createdBy
            createdByName
        }
        stockTransferId
        products {
            ...WarehouseDeliveryProductFragment
        }
        updatedAt
        ...URBANTZ_DELIVERY_FRAGMENT
    }
    ${WAREHOUSE_DELIVERY_PRODUCT_FRAGMENT}
    ${URBANTZ_DELIVERY_FRAGMENT}
`;
